import { render, staticRenderFns } from "./ItemStoreSpecial.vue?vue&type=template&id=4af85868"
import script from "./ItemStoreSpecial.vue?vue&type=script&lang=js"
export * from "./ItemStoreSpecial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports